import { jsx as _jsx } from "react/jsx-runtime";
import { DataTable, FlexBox, IconButton, MediaPlayer, Skeleton, } from '@dixa/lib-shared-habla';
import { useMemo } from 'react';
import { analytics } from 'app/utils/segment';
import { AppLink } from 'components/appLink';
import { translateAnnouncement, translateWaitMusic, } from 'utils/audio/translate';
export const Table = ({ isLoading, isError, retry, type, data, }) => {
    const items = useMemo(() => {
        var _a, _b;
        const isWaitMusic = type === 'wait-music';
        const items = isWaitMusic
            ? (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.wait_music
            : (_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.uploads;
        return ((items === null || items === void 0 ? void 0 : items.map((item) => isWaitMusic
            ? translateWaitMusic(item)
            : translateAnnouncement(item))) || []);
    }, [type, data]);
    return (_jsx(DataTable, { tableStatusProps: {
            loadingFailed: isError,
            onLoadingRetry: retry,
        }, columns: [
            {
                style: { width: '100%', maxWidth: '50%' },
                label: 'Name',
                selector: (item) => isLoading ? _jsx(Skeleton, { height: "14px", width: "30%" }) : item.name,
            },
            {
                label: 'Preview File',
                selector: (item) => isLoading ? (_jsx(Skeleton, { height: "56px", width: "100%", borderRadius: "100" })) : (_jsx(MediaPlayer, { lazy: true, mediaFile: {
                        src: item.url,
                        type: 'audio/mpg',
                    } })),
            },
            {
                style: { width: 1 },
                selector: (item) => isLoading ? (_jsx(FlexBox, Object.assign({ width: "32px", justifyContent: "center" }, { children: _jsx(Skeleton, { height: "18px", width: "18px" }) }))) : (_jsx(AppLink, Object.assign({ path: `/settings/audio/${type}/:id`, params: { path: { id: item.id } }, onClick: () => analytics.settingsAudioUsageLinkClicked({
                        type,
                        filename: item.name,
                    }) }, { children: _jsx(IconButton, { icon: "pen", variant: "tertiary" }) }))),
            },
        ], data: isLoading ? Array.from({ length: 20 }) : items }));
};
